import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject, Observable, of, catchError, switchMap, EMPTY, firstValueFrom } from 'rxjs';
import { Questions } from '../common-class/questions';
import { SaveOnNextData } from '../common-class/save-on-next-data';
import { participationMessages, SurveyMessages } from '../common-class/survey-messages';
import { GroupPiping, MatrixPiping, MatrixRandomiseList } from '../common-class/pages';
import { PreviewData, CommonSetting, OfflineSurvey, SignUp } from '../common-class/survey';
import { environment } from '../../environments/environment';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';
declare let $: any;
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const httpFileOPtions = {
  headers: new HttpHeaders({
    Accept: 'application/json',
  }),
};

const requestOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ParticipationDataService {
  basePath: string;
  path: string;
  isLoaded: boolean;
  surveykey: string;
  recno: number;
  GroupType: string;
  isRTL: boolean;
  embedId: number
  // PRT 102718
  ReEnterBlankMessage: string;
  questions: Array<Questions> = [];
  groupPipings: Array<GroupPiping> = [];
  matrixPipings: Array<MatrixPiping> = [];
  matrixRandomiseList: Array<MatrixRandomiseList> = [];
  preview: PreviewData;
  commonSetting: CommonSetting;
  signUp :SignUp;
  auth:boolean
  surveyMessages: SurveyMessages;
  OfflineSurvey: OfflineSurvey;
  isEx: boolean;
  dropDownCount: number;
  ImageFolder: string;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any;
  geoLocation: string;
  productName: string;
  isNewParticipation: boolean;
  surveyFormat: number;
  rsInputValue: number;
  questionchange: Questions;
  private renderer: Renderer2;
  newParticipationBtnText: string;
  isAutoScroll: boolean;
  isMobile: boolean;
  selectedLanguageCulture: string;
  answerPipeMessage: string;
  CustomAttachmentSizeSurveyID: string;
  strSurveyID: string;
  strCorpNo: string;
  CurrencyNegativeValueMessage: string;
  selectedLanguageId: number = 0;
  MDDdropDownCount: number;
  isPrevPgChnge: boolean = false;
  isEditPostPopSer: boolean = false;
  isEditResponse: boolean = false;

  constructor(
    public httpClient: HttpClient,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private emitChangeSource = new Subject<Questions>();

  public emitFormSubmitEvent = new BehaviorSubject<boolean>(false);
  public emitResetPageEvent = new Subject<boolean>();

  changeEmitted$ = this.emitChangeSource.asObservable();

  emitChange(myMessage: string, isLoaded: boolean) {
    this.basePath = myMessage;
    this.isLoaded = isLoaded;
    this.path = myMessage;
  }

  getBasePath(): string {
    return this.path;
  }

  setSureyDetails(
    surveykey: string,
    recno: number,
    GroupType: string,
    ReEnterBlankMessage: string,
    geoLocation: string,
    productName: string,
  ) {
    this.surveykey = surveykey;
    this.recno = recno;
    this.GroupType = GroupType;
    this.ReEnterBlankMessage = ReEnterBlankMessage;
    this.geoLocation = geoLocation;
    this.productName = productName;
  }

  setisEditPostPop(isEditPostPop: boolean) {
    this.isEditPostPopSer = isEditPostPop;
  }
  getisEditPostPop(): boolean {
    if (this.isEditPostPopSer) {
      return true;
    }
    return false;
  }

  setisEditResponse(isEditResponse: boolean) {
    this.isEditResponse = isEditResponse;
  }
  getisEditResponse(): boolean {
    if (this.isEditResponse) {
      return true;
    }
    return false;
  }

  setRTL(isRTL: boolean) {
    this.isRTL = isRTL;
  }

  setParticipationSurveyData(surveyFormat:number, newParticipationBtnText:string, isNewParticipation:boolean, isAutoScroll:boolean) {
    this.newParticipationBtnText = newParticipationBtnText;
    this.isNewParticipation = isNewParticipation;
    this.surveyFormat = surveyFormat;
    this.isAutoScroll = isAutoScroll;
  }
  
  setCustomAttachmentSizeSurveyID(CustomAttachmentSizeSurveyID: string) {
    this.CustomAttachmentSizeSurveyID = CustomAttachmentSizeSurveyID;
  }
  setSurveyID(strSurveyID: string) {
    this.strSurveyID = strSurveyID;
  }
  setCorpNo(strCorpNo: string) {
    this.strCorpNo = strCorpNo;
  }

  setMobile(isMobile: boolean) {
    this.isMobile = isMobile;
  }

  getSurveykey(): string {
    return this.surveykey;
  }

  setCurrencyNegativeMessage(message: string) {
    this.CurrencyNegativeValueMessage = message;
  }

  getCurrencyNegativeMessage(): string {
    return this.CurrencyNegativeValueMessage;
  }

  setRecNo(recNo:number){
    this.recno = recNo;
  }

  getRecNO(): number {
    return this.recno;
  }

  getGroupType(): string {
    return this.GroupType;
  }

  getRTL(): boolean {
    return this.isRTL;
  }
  getMobile(): boolean {
    return this.isMobile;
  }

  // PRT 102718
  getReEnterBlankMessage(): string {
    return this.ReEnterBlankMessage;
  }

  setPreviewData(preview: PreviewData) {
     this.preview = preview;
  }
  getPreviewData(): PreviewData {
    return this.preview;
  }

  setCommonSetting(commonSetting: CommonSetting) {
    this.commonSetting = commonSetting;
  }

  getCommonSetting(): CommonSetting {
    return this.commonSetting;
  }

  setAuth(isauth:boolean)
  {
    this.auth = isauth;
  }
  getAuth():boolean
  {
    return this.auth;
  }

  setSignUp(signUp: SignUp) {
    this.signUp = signUp;
  }

  setEmbedId(embedid: number) {
    this.embedId = embedid;
  }

  getEmbedId() {
    return this.embedId;
  }

  getSignup(): SignUp {
    return this.signUp;
  }

  setSurveyMessages(surveyMessages: SurveyMessages) {
    this.surveyMessages = surveyMessages;
  }
  getSurveyMessages(): SurveyMessages {
    return this.surveyMessages;
  }
  getIsEx(): boolean {
    return this.isEx;
  }

  setIsEx(IsEx: boolean) {
    this.isEx = IsEx;
  }

  getdropDownCount(): number {
    return this.dropDownCount;
  }
  setdropDownCount(dropDownCount: number) {
    this.dropDownCount = dropDownCount;
  }

  getImageFolder(): string {
    return this.ImageFolder;
  }
  setImageFolder(ImageFolder: string) {
    this.ImageFolder = ImageFolder;
  }

  setOfflineSurvey(offlineSurvey: OfflineSurvey) {
    this.OfflineSurvey = offlineSurvey;
  }

  getOfflineSurvey(): OfflineSurvey {
    return this.OfflineSurvey;
  }

  getMDDdropDownCount(): number {
    return this.MDDdropDownCount;
  }
  setMDDdropDownCount(MDDdropDownCount: number) {
    this.MDDdropDownCount = MDDdropDownCount;
  }


  public GetData(url: string): any {
    this.isLoaded = true;
    return this.httpClient.get<any>(this.basePath + url);
  }

  public GetDataProp(url: string): any {
    this.isLoaded = true;
    return this.httpClient.get<any>(this.basePath + url, httpOptions);
  }

  public GetDataPropAll(url: string, jsonData: string): any {
    this.isLoaded = true;
    return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions);
  }
  public EditResp(url: string, jsonData: string): Observable<any> {
    this.isLoaded = true;
    const idToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    const makeRequest = (token: string): Observable<any> => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        })
      };
      return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions);
    };

    if (!idToken) {
      window.location.href = `${environment.ms_host_ssl}/static/logout.html`;
      return EMPTY;
    }

    const isTokenExpired = (token: string): boolean => {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiry = payload.exp;
        return Math.floor(Date.now() / 1000) >= expiry;
      } catch (e) {
        return true;
      }
    };

    if (!isTokenExpired(idToken)) {
      return makeRequest(idToken);
    }

    if (refreshToken) {
      const credentials = JSON.stringify({
        accessToken: idToken,
        refreshToken: refreshToken
      });

      return this.httpClient.post<any>(`${environment.navURL}Auth/refresh`, credentials, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "X-Auth-Skip": "true",
          "X-File-Upload": "true"
        })
      }).pipe(
        switchMap((res: any) => {
          const decryptedString = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', res.payload);
          let parsedBody;
          try {
            parsedBody = JSON.parse(decryptedString);
          } catch (error) {
            console.error("Error parsing decrypted response:", error);
            return EMPTY;
          }

          const newAccessToken = parsedBody.Data.AccessToken;
          localStorage.setItem('access_token', newAccessToken);
          localStorage.setItem("refresh_token", parsedBody.Data.RefreshToken);

          return makeRequest(newAccessToken);
        }),
        catchError(err => {
          window.location.href = `${environment.ms_host_ssl}/static/logout.html`;
          return EMPTY;
        })
      );
    } else {
      window.location.href = `${environment.ms_host_ssl}/static/logout.html`;
      return EMPTY;
    }
  }
  // public GetData(url: string): any {
  //   this.isLoaded = true;
  //   return this.httpClient.get<any>(url);
  // }

  public GetLocalData(url: string): any {
    this.isLoaded = true;
    return this.httpClient.get<any>(url);
  }

  public PostData(url: string, jsonData: string): any {
    return this.httpClient.post<SaveOnNextData>(this.basePath + url, jsonData, httpOptions);
  }

  public PostDataForSubmit(url: string, jsonData: string): any {
    return this.httpClient.post<participationMessages>(this.basePath + url, jsonData, httpOptions);
  }

  public PostErrorData(url: string, jsonData: string): any {
    return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions);
  }

  public JSErrorMail(url: string): any {
    return this.httpClient.post<any>(this.basePath + url, httpOptions);
  }

  public postDataUsingPromise(url: string, jsonData: string): Promise<any> {
    return firstValueFrom(this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions));
  }

  public postAttachedFile(url: string, formData: FormData): any {
    return this.httpClient.post<any>(this.basePath + url, formData, httpFileOPtions);
  }

  public DeleteSignatureFile(url: string): any {
    return this.httpClient.post<any>(this.basePath + url, requestOptions);
  }




  public PostCloseEvent(url: string, jsonData: string): any {
    return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions);
  }

  public PostPartialDataMail(url: string) {
    return this.httpClient.post<any>(this.basePath + url, httpOptions);
  }

  public postPrintData(url: string, jsonData: string) {
    return this.httpClient.post(this.basePath + url, jsonData, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response',
      responseType: 'blob',
    });
  }

  public GetOfflineModeData(url: string): any {
    return this.httpClient.get<any>(this.basePath + url);
  }

  SetQDL(question: Questions) {
    let updateItem = this.questions.find((e) => e.UniqueNumber == question.UniqueNumber);
    if (updateItem != null && updateItem != undefined) {
      let index = this.questions.indexOf(updateItem);
      this.questions[index] = question;
    } else {
      this.questions.push(question);
    }
  }

  ExecureRuleExpression(question: Questions, ruleExp: string): boolean {
    let ruleExpString = ruleExp;
    for (const qdlCond of question.QDLCondStatuses) {
      if (ruleExpString.indexOf(qdlCond.CondName.trim()) > -1) {
        if (qdlCond.Status) {
          ruleExpString = ruleExpString.replace(qdlCond.CondName.trim(), '1==1');
        } else {
          ruleExpString = ruleExpString.replace(qdlCond.CondName.trim(), '1==0');
        }
      }
    }
    ruleExpString = ruleExpString.replace(/AND/g, '&&').replace(/OR/g, '||');
    let result = false;

    try {
      result = Function('return ' + ruleExpString)();
    } catch (e) {
      result = false;
    }
    return result;
  }

  GetQDL(CQ_QID: number): Questions {
    let updateItem = this.questions.find((e) => e.UniqueNumber == CQ_QID);
    if (updateItem != null && updateItem != undefined) {
      if (
        updateItem.QDLCondStatuses != null &&
        updateItem.QDLCondStatuses != undefined &&
        this.ExecureRuleExpression(updateItem, updateItem.QDLCondStatuses[0].rule_expression)
      ) {
        let index = this.questions.indexOf(updateItem);
        return this.questions[index];
      }
    }

    return null;
  }

  setPiping(groupPiping: GroupPiping) {
    let updateItem = this.groupPipings.find((e) => e.group_no == groupPiping.group_no);

    if (updateItem != null && updateItem != undefined) {
      let index = this.groupPipings.indexOf(updateItem);
      this.groupPipings[index] = groupPiping;
    } else {
      this.groupPipings.push(groupPiping);
    }
  }

  getPiping(group_no: number): string {
    let updateItem = this.groupPipings.find((e) => e.group_no == group_no);

    if (updateItem != null && updateItem != undefined) {
      let index = this.groupPipings.indexOf(updateItem);
      return this.groupPipings[index].pipeTitle;
    }
    return null;
  }

  setMatrixPiping(matrixPiping: MatrixPiping) {
    let updateItem = this.matrixPipings.find((e) => e.matrix_id == matrixPiping.matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixPipings.indexOf(updateItem);
      this.matrixPipings[index] = matrixPiping;
    } else {
      this.matrixPipings.push(matrixPiping);
    }
  }

  getMatrixPiping(matrix_id: number): string {
    let updateItem = this.matrixPipings.find((e) => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixPipings.indexOf(updateItem);
      return this.matrixPipings[index].pipeTitle;
    }
    return null;
  }

  setMatrixRandomList(matrix_id: number, uniqueList: any) {
    let updateItem = this.matrixRandomiseList.find((e) => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      updateItem.uniqueList = uniqueList;
      let index = this.matrixRandomiseList.indexOf(updateItem);
      this.matrixRandomiseList[index].uniqueList = uniqueList;
    } else {
      let matrixuniqueList: MatrixRandomiseList = new MatrixRandomiseList();
      matrixuniqueList.matrix_id = matrix_id;
      matrixuniqueList.uniqueList = uniqueList;
      this.matrixRandomiseList.push(matrixuniqueList);
    }
  }

  getMatrixRandomList(matrix_id: number): any {
    let updateItem = this.matrixRandomiseList.find((e) => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixRandomiseList.indexOf(updateItem);
      return this.matrixRandomiseList[index].uniqueList;
    }
    return null;
  }

  setIsCapchaMandatorySkip(isCapchaManditorySkip: boolean) {
    this.isCapchaManditorySkip = isCapchaManditorySkip;
  }

  getIsCapchaMandatorySkip() {
    return this.isCapchaManditorySkip;
  }

  setPageIsSoftRequiredHandle(pageIsSoftRequiredHandle: boolean) {
    this.pageIsSoftRequiredHandle = pageIsSoftRequiredHandle;
  }

  getPageIsSoftRequiredHandle() {
    return this.pageIsSoftRequiredHandle;
  }

  setNextButtonClickNo(nextButtonClickNo: number) {
    this.nextButtonClickNo = nextButtonClickNo;
  }

  getNextButtonClickNo() {
    return this.nextButtonClickNo;
  }

  getGeoLocation(): string {
    return this.geoLocation;
  }

  getProductName(): string {
    return this.productName;
  }

  getQuestionChange(): Questions {
    return this.questionchange;
  }
  setQuestionChange(questionchange: Questions) {
    this.questionchange = questionchange;
  }

  setAnswerPipeMessage(answerPipeMessage: string) {
    this.answerPipeMessage = answerPipeMessage;
  }

  getAnswerPipeMessage(): string {
    return this.answerPipeMessage;
  }
  setPrevPgChnge(isPrevPgChnge: boolean) {
    this.isPrevPgChnge = isPrevPgChnge;
  }
  getPrevPgChnge(): boolean {
    return this.isPrevPgChnge;
  }

  showQuestion(element: any) {
    this.renderer.addClass(element, 'active-ques');
    this.renderer.removeClass(element, 'inactive-ques');
  }

  hideQuestion(element: any) {
    this.renderer.removeClass(element, 'active-ques');
    this.renderer.addClass(element, 'inactive-ques');
  }
checkActivFn(){
  const activeElements = document.querySelectorAll('.main-ques-cont.active-ques');
  
  activeElements.forEach((el, index) => {
    if (index > 0) {
      el.classList.remove('active-ques');
      el.classList.add('inactive-ques');
    }
  });
}


  gotoNextQuestion(question: Questions, event) {
    if (this.getQuestionChange() && question.UniqueNumber == this.getQuestionChange().UniqueNumber && this.getQuestionChange().isValid && question.isValid) {
      return;
    }
    this.checkActivFn();
    if($(event).closest('.active-ques').length == 0) {
      let tempInactive = $(event).closest('.inactive-ques');
      let tempActive = $('.active-ques');
      tempInactive.removeClass('inactive-ques');
      tempInactive.addClass('active-ques');
      tempActive.removeClass('active-ques');
      tempActive.addClass('inactive-ques');
    }

    let self = this;
    let elemQues = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-overlay');
    let elemBtn = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-response-btn');
    let elemBtnCount = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-response-btn').length;
    let preElemBtnCount = $('.active-ques').find('.ques-response-btn').length;
    let nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
    let currElem = $('.active-ques');
    let noNextElem = true;
    let prevElem = $(event).closest('.active-ques');
    
    if (this.preview) {
      const previewPath = window.location.href;
      if(previewPath.includes('survey/form')){
        this.preview.viewport = '';
      }
    }
   let scrollTargetElement = $('#bodyScroll');
    const checkIfPrevirew = this.preview && this.preview.viewport;
    let nextElem = prevElem.nextAll('.inactive-ques').has('.question-data').eq(0);
    while(noNextElem) {

      if(nextElem.length > 0) {
        if(nextElem.find('.question-data').attr('hidden') != 'hidden') {
          noNextElem = false;
        } else {
          prevElem = nextElem;
          nextElem = prevElem.nextAll('.inactive-ques').has('.question-data').eq(0);
        }
      } else {
        noNextElem = false;
        nextbtnLength = 0;
      }
    }

    let minusScroll = 0;
    if($('.new-participation-focus').length > 0) {
      if(nextbtnLength > 0) {
        let elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
        $(window).unbind('scroll');

        $('body').off('mouseover', '.ques-overlay');
        if(checkIfPrevirew && checkIfPrevirew != ''){
          if(this.preview.viewport === "web"){
            elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
          }
          else {
            scrollTargetElement = $('.app-participation');
            elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
        } else {
          elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        scrollTargetElement.unbind('scroll');
        scrollTargetElement.animate({
          scrollTop: elemPosition
        }, 400, () => {
          if(nextElem.nextAll('.active-ques').length == 0)
          {
            currElem.removeClass('active-ques');
            currElem.addClass('inactive-ques');
            nextElem.addClass('active-ques');
            nextElem.removeClass('inactive-ques');
          }
          setTimeout(function() {
            self.lastScrollTop =  scrollTargetElement.scrollTop();
            self.showNewParticipationScroll();
          }, 100);

          setTimeout(function() {
            $("body").on("mousemove", ".ques-overlay", function() {
              self.activateQuestionOnHover(this);
              $("body").on("mouseover", ".ques-overlay", function() {
                self.activateQuestionOnHover(this);
              });
            });
          }, 500);
        });
        
      } else {
        if(checkIfPrevirew && checkIfPrevirew != ''){
          if(this.preview.viewport === "web"){
            scrollTargetElement = $('#bodyScroll');
          }
          else {
            scrollTargetElement = $('.app-participation');
          }
        }
        const scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();
        
        scrollTargetElement.animate({
          scrollTop: scrollVal
        }, 400, () => {
          if($('.next-button').length > 0) {
            $('.next-button').addClass('animateFooterIncrease');
          } else if($('.submit-button').length > 0) {
            $('.submit-button').addClass('animateFooterIncrease');
          }
          setTimeout(function() {
            if($('.next-button').length > 0) {
              $('.next-button').addClass('animateFooterDecrease');
            } else if($('.submit-button').length > 0) {
              $('.submit-button').addClass('animateFooterDecrease');
            }
          }, 250);
          setTimeout(function() {
            if($('.next-button').length > 0) {
              $('.next-button').removeClass('animateFooterIncrease');
              $('.next-button').removeClass('animateFooterDecrease');
            } else if($('.submit-button').length > 0) {
              $('.submit-button').removeClass('animateFooterIncrease');
              $('.submit-button').removeClass('animateFooterDecrease');
            }
          }, 450);
        });
      }
    } else {
    if(nextbtnLength > 0) {
      let elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top ;
      elemPosition = elemPosition - 50;
      if(checkIfPrevirew && checkIfPrevirew != ''){
        if(this.preview.viewport === "web"){
          elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
        }
        else {
          scrollTargetElement = $('.app-participation');
          elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
      } else {
        elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
      }
      if(elemQues.outerHeight() > $(window).height()){
        if(elemBtnCount > 0 && preElemBtnCount > 0){
          minusScroll = (elemBtn.outerHeight() * 2) - 10;
        } else {
          if(elemBtnCount > 0){
            minusScroll = elemBtn.outerHeight();
          } else if(preElemBtnCount > 0){
            minusScroll = $('.active-ques').find('.ques-response-btn').outerHeight() + 15;
          } 
        }
      } else {
        if(elemBtnCount > 0 && preElemBtnCount > 0){
          minusScroll = ($(window).height() - elemQues.outerHeight())/2 - 10;
        } else {
          if(elemBtnCount > 0){
            minusScroll = ($(window).height() - elemQues.outerHeight())/2 - elemBtn.outerHeight();
          } else if(preElemBtnCount > 0) {
            minusScroll = ($(window).height() - elemQues.outerHeight())/2 + $('.active-ques').find('.ques-response-btn').outerHeight();
          } else {
            minusScroll = ($(window).height() - elemQues.outerHeight())/2;
          }
        }
      }
      if($('body').hasClass('embed-survey')){
        minusScroll = 0;
      }
      setTimeout(() => {
        if(elemQues.closest('.active-ques').length == 0) {
          currElem.removeClass('active-ques');
          currElem.addClass('inactive-ques');
          nextElem.addClass('active-ques');
          nextElem.removeClass('inactive-ques');
        }
      }, 500);
      scrollTargetElement.animate({
        scrollTop: elemPosition - minusScroll
      }, 400);
    } else {
      if(checkIfPrevirew && checkIfPrevirew != ''){
        if(this.preview.viewport === "web"){
          scrollTargetElement = $('#bodyScroll');
        }
        else {
          scrollTargetElement = $('.app-participation');
        }
      }
      const scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();

      scrollTargetElement.animate({
        scrollTop: scrollVal
      }, 400, () => {
        if($('.next-button').length > 0) {
          $('.next-button').addClass('animateFooterIncrease');
        } else if($('.submit-button').length > 0) {
          $('.submit-button').addClass('animateFooterIncrease');
        }
        setTimeout(function() {
          if($('.next-button').length > 0) {
            $('.next-button').addClass('animateFooterDecrease');
          } else if($('.submit-button').length > 0) {
            $('.submit-button').addClass('animateFooterDecrease');
          }
        }, 250);
        setTimeout(function() {
          if($('.next-button').length > 0) {
            $('.next-button').removeClass('animateFooterIncrease');
            $('.next-button').removeClass('animateFooterDecrease');
          } else if($('.submit-button').length > 0) {
            $('.submit-button').removeClass('animateFooterIncrease');
            $('.submit-button').removeClass('animateFooterDecrease');
          }
        }, 450);
      });
    }
  }
}

  getSiblingWithClass(
    element: HTMLElement,
    direction: 'next' | 'prev',
    className: string,
    requiredChildSelector: string
  ): HTMLElement | null {
    let sibling: HTMLElement | null = element;
    while (sibling) {
      sibling = direction === 'next' ? sibling.nextElementSibling as HTMLElement : sibling.previousElementSibling as HTMLElement;
      if (sibling && sibling.classList.contains(className) && sibling.querySelector && sibling.querySelector(requiredChildSelector)) {
        return sibling;
      }
    }
    return null;
  }


  activateQuestion(obj, objPos, direction) {
    //objPos is the position + ht of the current active question
    let switchPosition = $(window).height() * 0.5;
    let switchPosition2 = $(window).height() * 0;
    let switchPosition3 = $(window).height() * 0.7;
    let scrollTargetElement = null;
    const checkIfPrevirew = this.preview && this.preview.viewport;
    if(checkIfPrevirew && checkIfPrevirew != ''){
      if(this.preview.viewport === "web"){
        scrollTargetElement = $('#bodyScroll');
      }
      else {
        scrollTargetElement = $('.app-participation');
      }
    } else {
      scrollTargetElement = $('#bodyScroll');
    }
  
    if (direction == 'down') {
      const nextElement = obj.nextAll('.inactive-ques').has('.question-data').eq(0);
      if (objPos < switchPosition && objPos && nextElement.length > 0) {
        nextElement.addClass('active-ques');
        nextElement.removeClass('inactive-ques');
        obj.removeClass('active-ques');
        obj.addClass('inactive-ques');
      }
    } else {
      const prevElement = obj.prevAll('.inactive-ques').has('.question-data').eq(0);
      if (prevElement.length > 0) {
        const prevElemPos =
          (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - scrollTargetElement.offset().top + scrollTargetElement.scrollTop()) - scrollTargetElement.scrollTop();
        const prevElemPosWithHt =
        (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - scrollTargetElement.offset().top + scrollTargetElement.scrollTop()) - scrollTargetElement.scrollTop() +
          obj.prevAll('.inactive-ques').has('.question-data').eq(0).outerHeight();
        if (
          (prevElemPos >= switchPosition2 || prevElemPosWithHt > switchPosition3) &&
          prevElement.length > 0
        ) {
          prevElement.addClass('active-ques');
          prevElement.removeClass('inactive-ques');
          obj.removeClass('active-ques');
          obj.addClass('inactive-ques');
        }
      }
    }
  }

  lastScrollTop = 0;
  showNewParticipationScroll() {
    let self = this;
    let scrollTargetElement = null;
    const checkIfPrevirew = this.preview && this.preview.viewport;
    if(checkIfPrevirew && checkIfPrevirew != ''){
      if(this.preview.viewport === "web"){
        scrollTargetElement = $('#bodyScroll');
      }
      else {
        scrollTargetElement = $('.app-participation');
      }
    } else {
      scrollTargetElement = $('#bodyScroll');
    } 
    scrollTargetElement.unbind('scroll');
    scrollTargetElement.scroll(function () {
      if ($('.active-ques').length > 0) {
        let activeElemPos = ($('.active-ques').offset().top - scrollTargetElement.offset().top + scrollTargetElement.scrollTop()) + $('.active-ques').outerHeight() - scrollTargetElement.scrollTop();
        if (
          self.lastScrollTop != 0 &&
          !(scrollTargetElement.scrollTop() < 0 || self.lastScrollTop < 0) &&
          scrollTargetElement.scrollTop() != self.lastScrollTop
        ) {
          if (scrollTargetElement.scrollTop() >= self.lastScrollTop) {
            self.activateQuestion($('.active-ques'), activeElemPos, 'down');
          } else {
            self.activateQuestion($('.active-ques'), activeElemPos, 'up');
          }
        }
        self.lastScrollTop = scrollTargetElement.scrollTop();
      }
    });
  }

  activateQuestionOnHover(element) {
    let scrollTargetElement = null;
    const checkIfPrevirew = this.preview && this.preview.viewport;
    if(checkIfPrevirew && checkIfPrevirew != ''){
      if(this.preview.viewport === "web"){
        scrollTargetElement = $('#bodyScroll');
      }
      else {
        scrollTargetElement = $('.app-participation');
      }
    } else {
      scrollTargetElement = $('#bodyScroll');
    }

    if (this.surveyFormat == 1) {
      $('.active-ques').addClass('inactive-ques');
      $('.active-ques').removeClass('active-ques');
      $(element).closest('.inactive-ques').addClass('active-ques');
      $(element).closest('.inactive-ques').removeClass('inactive-ques');
    }
  }

  setSelectedLanguageCulture(selectedLanguageCulture: string) {
    this.selectedLanguageCulture = selectedLanguageCulture;
  }

  getSelectedLanguageCulture() {
    return this.selectedLanguageCulture;
  }

  setSelectedLanguage(selectedLanguage: number) {
    this.selectedLanguageId = selectedLanguage;
  }

  getSelectedLanguage(): number {
    return this.selectedLanguageId;
  }

  // Safe querySelector utility method
  safeQuerySelector(selector: string, parent: Document | Element = document): Element | null {
    try {
      if (!parent || !parent.querySelector) {
        return null;
      }
      return parent.querySelector(selector);
    } catch (error) {
      console.warn('Error in safeQuerySelector:', error);
      return null;
    }
  }

  // Safe querySelectorAll utility method
  safeQuerySelectorAll(selector: string, parent: Document | Element = document): NodeListOf<Element> | null {
    try {
      if (!parent || !parent.querySelectorAll) {
        return null;
      }
      return parent.querySelectorAll(selector);
    } catch (error) {
      console.warn('Error in safeQuerySelectorAll:', error);
      return null;
    }
  }

  // Safe DOM element check
  isElementSafe(element: any): boolean {
    return element && 
           typeof element.querySelector === 'function' && 
           typeof element.querySelectorAll === 'function';
  }

  // Safe DOM operation wrapper
  safeDOMOperation<T>(operation: () => T, fallback: T): T {
    try {
      return operation();
    } catch (error) {
      console.warn('Error in DOM operation:', error);
      return fallback;
    }
  }
}
